import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './localization/config.js';
import { Provider } from 'react-redux';
import store from './reducers/store.js';
import './i18n.js';
import ThemeProvider from './lib/ThemeProvider/ThemeProvider.jsx';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './utils/setupAxios401Redirect';

// Create root
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render app + hide loader only AFTER first paint
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Provider store={store}>
        <DndProvider backend={HTML5Backend}>
          <App />
        </DndProvider>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);

// Hide loader ONLY after React has mounted and painted
const hideLoader = () => {
  const loader = document.getElementById('app-loader');
  if (loader) {
    loader.style.opacity = '0';
    // Remove from DOM after fade out
    setTimeout(() => loader.remove(), 600);
  }
};

// Option 1: Hide as soon as possible (recommended)
requestAnimationFrame(() => {
  requestAnimationFrame(hideLoader); // After first paint
});

// Option 2: Even better – wait for fonts + images (optional)
// window.addEventListener('load', hideLoader);

// Optional: Remove console.log in production (final fix)
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  // Keep warn/error if you want: console.warn = console.warn;
}

// Web vitals
reportWebVitals();